import { Corners } from "@/components/ui-kit";

const ORBIT = ["COMPUTE", "DATA", "SERVICES", "MACHINES", "TASKS", "PAYMENTS"];

const EconomyGraph = () => {
  const C = 280, R = 195;
  return (
    <div data-testid="economy-graph" className="hud-panel relative p-4 sm:p-8">
      <Corners />
      <svg viewBox="0 0 560 560" className="w-full max-w-xl mx-auto h-auto" role="img" aria-label="Circular machine economy diagram">
        <defs>
          <radialGradient id="coreGlow"><stop offset="0%" stopColor="#1688FF" stopOpacity="0.55" /><stop offset="100%" stopColor="#1688FF" stopOpacity="0" /></radialGradient>
        </defs>
        <circle cx={C} cy={C} r="120" fill="url(#coreGlow)" />
        <g className="anim-spin-slow" style={{ transformBox: "fill-box", transformOrigin: "center" }}>
          <circle cx={C} cy={C} r={R} fill="none" stroke="rgba(0,168,255,0.25)" strokeWidth="1" strokeDasharray="4 10" />
          {ORBIT.map((_, i) => {
            const a = (i / ORBIT.length) * Math.PI * 2 - Math.PI / 2;
            return <circle key={i} cx={C + R * Math.cos(a)} cy={C + R * Math.sin(a)} r="3.5" fill="#43D9FF" />;
          })}
        </g>
        <g className="anim-spin-slow-rev" style={{ transformBox: "fill-box", transformOrigin: "center" }}>
          <circle cx={C} cy={C} r={R - 55} fill="none" stroke="rgba(67,217,255,0.18)" strokeWidth="1" strokeDasharray="2 14" />
          <circle cx={C + (R - 55)} cy={C} r="4" fill="#00A8FF" />
          <circle cx={C - (R - 55)} cy={C} r="4" fill="#00A8FF" />
        </g>
        {ORBIT.map((label, i) => {
          const a = (i / ORBIT.length) * Math.PI * 2 - Math.PI / 2;
          const x = C + R * Math.cos(a), y = C + R * Math.sin(a);
          return (
            <g key={label}>
              <line x1={C + 70 * Math.cos(a)} y1={C + 70 * Math.sin(a)} x2={x} y2={y} stroke="rgba(0,168,255,0.3)" strokeWidth="1" className="anim-dash" />
              <circle cx={x} cy={y} r="24" fill="#06101C" stroke="rgba(0,168,255,0.5)" strokeWidth="1" />
              <text x={x} y={y + 42} textAnchor="middle" fill="#C9D2DC" fontSize="11" fontFamily="JetBrains Mono, monospace" letterSpacing="2">{label}</text>
            </g>
          );
        })}
        <circle cx={C} cy={C} r="62" fill="#020406" stroke="#1688FF" strokeWidth="1.5" />
        <circle cx={C} cy={C} r="54" fill="none" stroke="rgba(67,217,255,0.35)" strokeWidth="1" strokeDasharray="3 6" />
        <text x={C} y={C - 2} textAnchor="middle" fill="#F4F8FC" fontSize="17" fontWeight="700" fontFamily="Syne, sans-serif" letterSpacing="3">ARCMECH</text>
        <text x={C} y={C + 18} textAnchor="middle" fill="#43D9FF" fontSize="9" fontFamily="JetBrains Mono, monospace" letterSpacing="2">SETTLEMENT · ARC</text>
      </svg>
      <div className="mt-2 text-center font-mono text-[9px] tracking-[0.25em] text-arc-silver/35">CONCEPTUAL FLOW DIAGRAM</div>
    </div>
  );
};

export default EconomyGraph;
